module.exports = __webpack_public_path__ + "img/christmas-trees-8416168_1280_thumb.81828291.jpg";